import ExitToApp from '@material-ui/icons/ExitToApp';
import PermIdentity from '@material-ui/icons/PermIdentity';
import Lock from '@material-ui/icons/Lock';
import store from '../../store';
import { DOCTOR_ROUTES } from './routes';
import { logout } from '../../reducers/authenticationReducer';
import { redirect } from '../../helpers/redirect';

const toolbarMenuItems = [
  {
    translationKey: 'doctorDashboard.profile',
    label: '',
    icon: PermIdentity,
    action: () => redirect(DOCTOR_ROUTES.profile),
  },
  {
    translationKey: 'doctorDashboard.changePassword',
    label: '',
    icon: Lock,
    action: () => redirect(DOCTOR_ROUTES.changePassword),
  },
  {
    translationKey: 'doctorDashboard.logout',
    label: '',
    icon: ExitToApp,
    action: () => store.dispatch(logout())
  }
];

export default toolbarMenuItems;
